<template>
  <div class="col-xxl-5 col-xl-6 col-lg-7 text-center text-sm-left">
    <loading :active.sync="isLoading" :opacity=0.2 :width=50 :height=50>
    </loading>
    <div class="row justify-content-around gutter-vr-30px">
      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="bgSpace">
          <div class="status-info animated" data-animate="fadeInUp" data-delay="0.9">
            <div class="field-item noPadbtm animated fadeInUp" data-animate="fadeInUp" data-delay="0.8" style="visibility: visible; animation-delay: 0.8s;">
              <label class="field-label ttu"> QUICK VERIFICATION </label>
              <div class="image-preview" v-if="imageData.length > 0">
                <img ref="img" @load="decodeImg" :src=imageData style="display:none;" />
              </div>
              <transition name="fade" appear>
                <p v-if="errMsg" style="color: red !important;" class="text-center py-1 bg-white"><small>{{errMsg}}</small></p>
              </transition>
              <div class="field-wrap">
                <input name="contact-name" placeholder="000000-0000-000000000000-0-000000" type="text" class="input-bordered" v-model="serialNum" maxLength=33 value="hello">
              </div>
            </div>
            <div class="clearfix choose_file">
              <button href="#" class="btn btnwid" id="verifyNow" @click="showResult" v-bind:disabled="verifyBtn"><i class="fa fa-check"></i>&nbsp;&nbsp; Verify</button>
              <button href="#" class="btn btnA btnwid" @click="resetState"><i class="fa fa-upload"></i>&nbsp;&nbsp; Upload a file <input id="fileManager" name="img" type="file" accept="image/*" @change="previewImage" /> </button> 
              <button data-toggle="modal" data-target="#Verify" style="display: none" id="showModal"></button>
              <button data-toggle="modal" data-target="#ack-popup" style="display: none" id="showSignin"></button>
              <button href="#" class="btn btnB btnwid"  data-toggle="modal" data-target="#WebCamCapture" id="open-camera" @click ="toggleCam"><i class="fa fa-camera" id="onCam"></i>&nbsp;&nbsp;  Use Camera </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-undef */
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import QrcodeDecoder from 'qrcode-decoder'
import { BrowserQRCodeReader } from '@zxing/library'
import { bus } from '../main'

const serialNumberRegex = /^\d{6}-\d{4}-\d{12}-\d{1}-\d{6}$/

export default {
  components: {
    Loading
  },
  data () {
    return {
      serialNum: '',
      imageData: '',
      camResult: '',
      dataTarg: '',
      verifyBtn: true
    }
  },
  computed: {
    isLoading () {
      return this.$store.state.loading
    },
    errMsg () {
      return this.$store.state.errorMsg
    },
    serialChange () {
      return this.$store.state.serialInfo
    },
    errAck () {
      return this.$store.state.errorAck
    },
    serialInput () {
      return this.serialNum
    }
  },
  created () {
    bus.$on('camResult', (data) => {
      this.camResult = data
      if (this.camResult) {
        this.$store.dispatch('fetchSerialApi', this.camResult)
        this.camResult = ''
      }
    })
  },
  watch: {
    serialChange: function () {
      (this.$store.state.serialInfo) && $('#showModal').click();
    },
    errAck: function () {
      (this.$store.state.errorAck) && $('#showSignin').click()
    },
    serialInput: function () {
      (this.serialNum === '') ? this.verifyBtn = true : this.verifyBtn = false
    }
  },
  methods: {
    toggleCam () {
      bus.$emit('toggleCam', true)
    },
    showResult () {
      this.$store.dispatch('fetchSerialApi', this.serialNum)
    },
    resetState () {
      this.$store.dispatch('resetState')
      this.imageData = ''
    },
    previewImage (event) {
      const input = event.target;

      if (input.files && input.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageData = e.target.result;
        }
        reader.readAsDataURL(input.files[0]);
      }
    },
    async decodeImg () {
      if (this.imageData) {
        try {
        const codeReader = new BrowserQRCodeReader()
        const qr = new QrcodeDecoder()
        var img = this.$refs.img
        const codeA = await qr.decodeFromImage(img);

          if (codeA.data) {
            this.serialNum = codeA.data;
          } else {
            const code = await codeReader.decodeFromImage(img);
            this.serialNum = code.text;
          }

          if (serialNumberRegex.test(this.serialNum)) {
            this.showResult();
            this.serialNum = ''
          } else if (!serialNumberRegex.test(this.serialNum) && this.serialNum) {
            this.$store.commit('isLoading', true)
            this.$store.commit('uploadRes', this.serialNum)
            this.$store.commit('isLoading', false)
            $('#showModal').click(); 
          } else {
            this.$store.commit('isLoading', true)
            this.$store.commit('errorMsg', 'No QR Code was found in this image')
            setTimeout(() => {
              this.$store.commit('errorMsg', '')
            }, 5000);
            this.$store.commit('isLoading', false)           
          }
        } catch (error) {
          if (error.response === undefined) {
            this.$store.commit('isLoading', true)
            this.$store.commit('errorMsg', 'No QR Code was found in this image')
            setTimeout(() => {
              this.$store.commit('errorMsg', '')
            }, 5000);
            this.$store.commit('isLoading', false)              
          }
        }
        $('#fileManager').val("");
      }
    },
  }
}
</script>

<style scoped>
  .fade-enter {
    opacity: 0;
  }
  .fade-enter-active {
    transition: opacity 2s;
  }
  .fade-leave-active {
    transition: opacity 1s;
    opacity: 0;
  }
</style>
